/*
 * TODO: MIGRATE TO NATIVE BOOTSTRAP TOASTS
 * https://getbootstrap.com/docs/5.1/components/toasts/
 */
import Toastify from "toastify-js";

/**
 * Triggers the display of a green toast notification in the upper right hand
 * side of the window with the inputted message.
 *
 * Built on top of https://github.com/apvarun/toastify-js/blob/master/README.md
 * @param message
 */
export function sendSuccessNotification(message) {
    Toastify({
        text: message,
        duration: 5000, // destination: "https://app.argusdevicemanager.com",
        newWindow: true,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
            background: "#00a36c",
        }, onClick: function () {
        } // Callback after click
    }).showToast();
}

/**
 * Triggers the display of a red toast notification in the upper right hand
 * side of the window with the inputted message.
 *
 * Built on top of https://github.com/apvarun/toastify-js/blob/master/README.md
 * @param message
 */
export function sendFailureNotification(message) {
    Toastify({
        text: message,
        duration: 5000, // destination: "https://app.argusdevicemanager.com",
        newWindow: true,
        close: true,
        gravity: "top", // `top` or `bottom`
        position: "right", // `left`, `center` or `right`
        stopOnFocus: true, // Prevents dismissing of toast on hover
        style: {
            background: "#b03c3f",
        }, onClick: function () {
        } // Callback after click
    }).showToast();
}